import analyticsApi from './../../api/analytics';
import guid from './../../mixins/guid';
const state = {
    sessionId: '',
    showFeedback: false
};

const getters = {
    showFeedback (state) {
        return state.showFeedback;
    }
};

const actions = {
    setSessionId ({ commit}) {
        commit('setSessionId', guid.methods.generateGuid());
    },
    postAnalytics (context, data) {
        data.sessionId = state.sessionId;
        analyticsApi.postAnalytics(data);
    }
};

const mutations = {
    postAnalytics (state, data) {
        data.sessionId = state.sessionId;
        analyticsApi.postAnalytics(data);
    },
    setValue (state, { prop, value }) {
        state[prop] = value;
    },
    setSessionId (state, value) {
        state.sessionId = value;
    },
    showFeedback (state, val) {
        state.showFeedback = val;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
